import { CartOperationlModels, DeadpoolUser, Store } from '~types/index'

const shouldRetrieveProvider = ({
  operationalModel,
  store,
  customer,
}: {
  operationalModel: CartOperationlModels
  store: Store
  customer: DeadpoolUser | null
}) => {
  if (store?.id && customer?.id && operationalModel) {
    return true
  }
  return false
}

export default shouldRetrieveProvider
